export function teamStatsCalculator(data, homeTeamId, awayTeamId) {
    let homeTeamStatistics = data?.statistics?.filter(
        (data) => data?.team?.id == homeTeamId
    );
    let awayTeamStatistics = data?.statistics?.filter(
        (data) => data?.team?.id == awayTeamId
    );

    const convertToPercentage = (value) => {
        let max;
        if (value == null) {
            max = 0;
        } else if (value <= 5) {
            max = 10;
        } else if (value <= 10) {
            max = 20;
        } else if (value <= 20) {
            max = 30;
        } else if (value <= 30) {
            max = 45;
        } else if (value > 100) {
            max = 1000;
        } else {
            max = 60; // Default maximum value
        }
        return (value / max) * 100;
    };

    let homeTeamShotsOnGoal = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Shots insidebox"
    );
    let homeTeamShotsOffGoal = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Shots outsidebox"
    );
    let homeTeamTotalShots = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Total Shots"
    );
    let homeTeamFouls = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Fouls"
    );
    let homeTeamCorner = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Corner Kicks"
    );
    let homeTeamOffsides = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Offsides"
    );
    let homeTeamPossession = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Ball Possession"
    );
    let homeTeamYellowCard = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Yellow Cards"
    );
    let homeTeamRedCard = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Red Cards"
    );
    let homeTeamPasses = homeTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Total passes"
    );

    let awayTeamShotsOnGoal = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Shots insidebox"
    );
    let awayTeamShotsOffGoal = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Shots outsidebox"
    );
    let awayTeamTotalShots = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Total Shots"
    );
    let awayTeamFouls = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Fouls"
    );
    let awayTeamCorner = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Corner Kicks"
    );
    let awayTeamOffsides = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Offsides"
    );
    let awayTeamPossession = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Ball Possession"
    );
    let awayTeamYellowCard = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Yellow Cards"
    );
    let awayTeamRedCard = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Red Cards"
    );
    let awayTeamPasses = awayTeamStatistics[0]?.statistics?.filter(
        (data) => data?.type == "Total passes"
    );

    let homeTeamShotsOnGoalPer = convertToPercentage(
        homeTeamShotsOnGoal[0]?.value
    );
    let homeTeamShotsOffGoalPer = convertToPercentage(
        homeTeamShotsOffGoal[0]?.value
    );
    let homeTeamTotalShotsPer = convertToPercentage(
        homeTeamTotalShots[0]?.value
    );
    let homeTeamFoulsPer = convertToPercentage(homeTeamFouls[0]?.value);
    let homeTeamCornerPer = convertToPercentage(homeTeamCorner[0]?.value);
    let homeTeamOffsidesPer = convertToPercentage(
        homeTeamOffsides[0]?.value
    );
    let homeTeamYellowCardPer = convertToPercentage(
        homeTeamYellowCard[0]?.value
    );
    let homeTeamRedCardPer = convertToPercentage(homeTeamRedCard[0]?.value);
    let homeTeamPassesPer = convertToPercentage(homeTeamPasses[0]?.value);

    let awayTeamShotsOnGoalPer = convertToPercentage(
        awayTeamShotsOnGoal[0]?.value
    );
    let awayTeamShotsOffGoalPer = convertToPercentage(
        awayTeamShotsOffGoal[0]?.value
    );
    let awayTeamTotalShotsPer = convertToPercentage(
        awayTeamTotalShots[0]?.value
    );
    let awayTeamFoulsPer = convertToPercentage(awayTeamFouls[0]?.value);
    let awayTeamCornerPer = convertToPercentage(awayTeamCorner[0]?.value);
    let awayTeamOffsidesPer = convertToPercentage(
        awayTeamOffsides[0]?.value
    );
    let awayTeamYellowCardPer = convertToPercentage(
        awayTeamYellowCard[0]?.value
    );
    let awayTeamRedCardPer = convertToPercentage(awayTeamRedCard[0]?.value);
    let awayTeamPassesPer = convertToPercentage(awayTeamPasses[0]?.value);

    // return {
    //     homeTeamPossession: homeTeamPossession[0]?.value,
    //     homeTeamRedCardPer,
    //     homeTeamShotsOnGoalPer,
    //     homeTeamShotsOffGoalPer,
    //     homeTeamTotalShotsPer,
    //     homeTeamYellowCardPer,
    //     homeTeamPassesPer,
    //     homeTeamFoulsPer,
    //     homeTeamCornerPer,
    //     homeTeamOffsidesPer,
    //     awayTeamShotsOnGoalPer,
    //     awayTeamTotalShotsPer,
    //     awayTeamFoulsPer,
    //     awayTeamYellowCardPer,
    //     awayTeamOffsidesPer,
    //     awayTeamPossession: awayTeamPossession[0]?.value,
    //     awayTeamShotsOffGoalPer,
    //     awayTeamRedCardPer,
    //     awayTeamPassesPer,
    //     awayTeamCornerPer,

    //     homeTeamShotsOnGoal: homeTeamShotsOnGoal[0]?.value,
    //     homeTeamShotsOffGoal: homeTeamShotsOffGoal[0]?.value,
    //     homeTeamTotalShots: homeTeamTotalShots[0]?.value,
    //     homeTeamFouls: homeTeamFouls[0]?.value,
    //     homeTeamCorner: homeTeamCorner[0]?.value,
    //     homeTeamOffsides: homeTeamOffsides[0]?.value,
    //     homeTeamYellowCard: homeTeamYellowCard[0]?.value,
    //     homeTeamRedCard: homeTeamRedCard[0]?.value,
    //     homeTeamPasses: homeTeamPasses[0]?.value,
    //     awayTeamShotsOnGoal: awayTeamShotsOnGoal[0]?.value,
    //     awayTeamShotsOffGoal: awayTeamShotsOffGoal[0]?.value,
    //     awayTeamTotalShots: awayTeamTotalShots[0]?.value,
    //     awayTeamFouls: awayTeamFouls[0]?.value,
    //     awayTeamCorner: awayTeamCorner[0]?.value,
    //     awayTeamOffsides: awayTeamOffsides[0]?.value,
    //     awayTeamYellowCard: awayTeamYellowCard[0]?.value,
    //     awayTeamRedCard: awayTeamRedCard[0]?.value,
    //     awayTeamPasses: awayTeamPasses[0]?.value,

    //     awayTeamName: awayTeamStatistics[0]?.team?.name,
    //     homeTeamName: homeTeamStatistics[0]?.team?.name,
    //     homeTeamLogo: homeTeamStatistics[0]?.team?.logo,
    //     awayTeamLogo: awayTeamStatistics[0]?.team?.logo,
    // }

return {
  homeTeamPossession: homeTeamPossession[0]?.value ?? 0,
  homeTeamRedCardPer: homeTeamRedCardPer ?? 0,
  homeTeamShotsOnGoalPer: homeTeamShotsOnGoalPer ?? 0,
  homeTeamShotsOffGoalPer: homeTeamShotsOffGoalPer ?? 0,
  homeTeamTotalShotsPer: homeTeamTotalShotsPer ?? 0,
  homeTeamYellowCardPer: homeTeamYellowCardPer ?? 0,
  homeTeamPassesPer: homeTeamPassesPer ?? 0,
  homeTeamFoulsPer: homeTeamFoulsPer ?? 0,
  homeTeamCornerPer: homeTeamCornerPer ?? 0,
  homeTeamOffsidesPer: homeTeamOffsidesPer ?? 0,
  awayTeamShotsOnGoalPer: awayTeamShotsOnGoalPer ?? 0,
  awayTeamTotalShotsPer: awayTeamTotalShotsPer ?? 0,
  awayTeamFoulsPer: awayTeamFoulsPer ?? 0,
  awayTeamYellowCardPer: awayTeamYellowCardPer ?? 0,
  awayTeamOffsidesPer: awayTeamOffsidesPer ?? 0,
  awayTeamPossession: awayTeamPossession[0]?.value ?? 0,
  awayTeamShotsOffGoalPer: awayTeamShotsOffGoalPer ?? 0,
  awayTeamRedCardPer: awayTeamRedCardPer ?? 0,
  awayTeamPassesPer: awayTeamPassesPer ?? 0,
  awayTeamCornerPer: awayTeamCornerPer ?? 0,

  homeTeamShotsOnGoal: homeTeamShotsOnGoal[0]?.value ?? 0,
  homeTeamShotsOffGoal: homeTeamShotsOffGoal[0]?.value ?? 0,
  homeTeamTotalShots: homeTeamTotalShots[0]?.value ?? 0,
  homeTeamFouls: homeTeamFouls[0]?.value ?? 0,
  homeTeamCorner: homeTeamCorner[0]?.value ?? 0,
  homeTeamOffsides: homeTeamOffsides[0]?.value ?? 0,
  homeTeamYellowCard: homeTeamYellowCard[0]?.value ?? 0,
  homeTeamRedCard: homeTeamRedCard[0]?.value ?? 0,
  homeTeamPasses: homeTeamPasses[0]?.value ?? 0,
  awayTeamShotsOnGoal: awayTeamShotsOnGoal[0]?.value ?? 0,
  awayTeamShotsOffGoal: awayTeamShotsOffGoal[0]?.value ?? 0,
  awayTeamTotalShots: awayTeamTotalShots[0]?.value ?? 0,
  awayTeamFouls: awayTeamFouls[0]?.value ?? 0,
  awayTeamCorner: awayTeamCorner[0]?.value ?? 0,
  awayTeamOffsides: awayTeamOffsides[0]?.value ?? 0,
  awayTeamYellowCard: awayTeamYellowCard[0]?.value ?? 0,
  awayTeamRedCard: awayTeamRedCard[0]?.value ?? 0,
  awayTeamPasses: awayTeamPasses[0]?.value ?? 0,

  awayTeamName: awayTeamStatistics[0]?.team?.name ?? "",
  homeTeamName: homeTeamStatistics[0]?.team?.name ?? "",
  homeTeamLogo: homeTeamStatistics[0]?.team?.logo ?? "",
  awayTeamLogo: awayTeamStatistics[0]?.team?.logo ?? "",
};

}